import type { MouseEvent as ReactMouseEvent } from 'react'

/**
 * Returns true when the user is asking the browser to open the target somewhere
 * other than the current tab: cmd/ctrl-click (new tab), shift-click (new window)
 * or middle-click. In-app navigation must step aside and let the browser handle
 * such clicks natively (anchors) or open the path itself (non-anchor elements).
 */
export function isNewTabClick(event: ReactMouseEvent | MouseEvent): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1
}
